module.exports = __webpack_public_path__ + "static/media/sia-support-socass.020eaa80.png";